import React from "react"
import { useServiceAreasSectionQuery } from '../hooks/use-service-areas-section-query'
import { useCourtsQuery } from '../hooks/use-courts-query'
import styled from '@emotion/styled/macro'
import { Link } from 'gatsby'
import { Theme2 } from "./Layout"



const AccordionContent = ({resultsTabTitle, isHomePage, paddingBottom }) =>{
const AccordionContainer = styled.div`
 background-color: ${Theme2.colors.light};
   padding: ${isHomePage === true ? `2rem 3rem` : 0};
   text-align: left;
  padding-bottom: ${paddingBottom === true ? `1.3em`:0};

  
   .tabs {
  overflow: hidden;
  text-align: left;
}
.tab {
  position: relative;
  width: 100%;
  color: ${Theme2.colors.primary};
  overflow: hidden;
  &-label {
    display: flex;
    justify-content: space-between;
    padding: 1em 0;
    background: ${Theme2.colors.light};
    color: ${Theme2.colors.primary};
    font-weight: 700;
    font-family: "Playfair Display",serif;
    cursor: pointer;
    border-bottom: 1px solid ${Theme2.colors.neutral};
    font-size: 1rem;
    @media(min-width: 992px){
      font-size: 1.5rem;
    }
    /* Icon */
    &::after{
  content: '\\276F';
      width: 1em;
      height: 1em;
      text-align: center;
      transition: all .35s;
      color: ${Theme2.colors.tertiary};
}
    
  }
  &-content {
    max-height: 0;
    color: ${Theme2.colors.primary};
    transition: all .35s;
  }
  input{
    position: absolute;
    opacity: 0;
    z-index: -1;
  }
  
}

input:checked {
  + .tab-label {
    background: ${Theme2.colors.light};
    &::after {
      transform: rotate(90deg);
    }
  }
  ~ .tab-content {
    max-height: 150px;
    padding: 1em 0;
    overflow-y: auto;
  }
}

 .page-generator-pro-related-links{
   display: inline-block;
   @media(min-width:992px){
     display: block;
    column-count: 3;
  column-gap: ${resultsTabTitle === "Courts" ? `15px`: 0};
   }
   li:first-of-type{
     margin: 0 0 1rem 0;
   }
 }
 .viewAllLink{
   display: inline-block;
   background-color: ${Theme2.colors.primary};
   color: ${Theme2.colors.light};
   margin: 1em 0; 
   text-transform: uppercase;
   padding: 20px 30px;
   font-size: 14px;
   letter-spacing: 2px;
   transition: all .5s;
   &:hover{
    background-color: ${Theme2.colors.tertiary};
   }
 }
`
const {serviceAreasAccordionContentCriminalDefense,
  serviceAreasAccordionContentPersonalInjury,
  serviceAreasAccordionContentFamilyLaw, serviceAreasViewAllButton}  = useServiceAreasSectionQuery()
  const {courtsWeServe} = useCourtsQuery()
  const activeTab = resultsTabTitle;

    
      if(activeTab === "Criminal Defense"){
        return(
          <AccordionContainer>
          <div dangerouslySetInnerHTML={{__html: serviceAreasAccordionContentCriminalDefense}} />
          <div style={{display: 'none'}} dangerouslySetInnerHTML={{__html: serviceAreasAccordionContentPersonalInjury}} />
<div style={{display: 'none'}} dangerouslySetInnerHTML={{__html: serviceAreasAccordionContentFamilyLaw}} />
          {isHomePage &&
          <Link className="viewAllLink" to={serviceAreasViewAllButton.url}>{serviceAreasViewAllButton.title}</Link>
          }
          </AccordionContainer>
        )
      }
      else if(activeTab === "Personal Injury"){
        return(
          <AccordionContainer>
          <div dangerouslySetInnerHTML={{__html: serviceAreasAccordionContentPersonalInjury}} />
          {isHomePage &&
          <Link className="viewAllLink" to={serviceAreasViewAllButton.url}>{serviceAreasViewAllButton.title}</Link>
          }
          </AccordionContainer>
        )
      }
      else if(activeTab === "Family Law"){
        return(
          <AccordionContainer>
          <div dangerouslySetInnerHTML={{__html: serviceAreasAccordionContentFamilyLaw}} />
          {isHomePage &&
          <Link className="viewAllLink" to={serviceAreasViewAllButton.url}>{serviceAreasViewAllButton.title}</Link>
         }
          </AccordionContainer>
        )
      }
      else if(activeTab === "Courts"){
        return(
          <AccordionContainer>
          <div dangerouslySetInnerHTML={{__html: courtsWeServe}} />
          </AccordionContainer>
        )
      }
      else{
        return(
          <>
          There has been an error.
          </>
        )
      }    
}
export default AccordionContent